import { RouteConfig } from 'vue-router'

const initConfig = () => import('../views/school-manage-init/SchoolManageInit.vue')
const Intro = () => import('../views/school-manage-init/Intro.vue')
const PrepareMaterials = () => import('../views/school-manage-init/PrepareMaterials.vue')
const InitCertificate = () => import('../views/school-manage-init/SchoolCertificateInit.vue')

export const introRoute: RouteConfig = {
  path: '/school-certification-intro',
  name: 'school_certification_intro',
  component: Intro,
}

export const prepareMaterialsRoute: RouteConfig = {
  path: '/school-certification-prepare-materials',
  name: 'school_certification_prepare_materials',
  component: PrepareMaterials,
}

export const initConfigStartRoute: RouteConfig = {
  path: '/school-manage-init/start',
  name: 'school_manage_init_start',
  component: () => import('@/views/school-manage-init/Start.vue'),
  meta: {
    title: '初始化设置',
  },
}

export const initCertificateRoute: RouteConfig = {
  path: '/school-certificate-init',
  name: 'school_certificate_init',
  component: InitCertificate,
  meta: {
    title: '初始化设置',
  },
  children: [
    {
      ...initConfigStartRoute,
      name: 'school_certificate_init_start',
    },
    {
      path: 'step1',
      name: 'school_certificate_init_step1',
      component: () => import('@/views/school-manage-init/CertificateStep1.vue'),
      meta: {
        title: '初始化设置（1/3）',
      },
    },
    {
      path: 'step2',
      name: 'school_certificate_init_step2',
      component: () => import('@/views/school-manage-init/CertificateStep2.vue'),
      meta: {
        title: '初始化设置（2/3）',
      },
    },

    {
      path: 'step3',
      name: 'school_certificate_init_step3',
      component: () => import('@/views/school-manage-init/CertificateStep3.vue'),
      meta: {
        title: '初始化设置（3/3）',
      },
    },
    {
      path: 'success',
      name: 'school_certificate_init_success',
      component: () => import('@/views/school-manage-init/CertificateSuccess.vue'),
    },
  ],
}

export const initConfigRoute: RouteConfig = {
  path: '/school-manage-init',
  name: 'school_manage_init',
  component: initConfig,
  meta: {
    title: '初始化设置',
  },
  children: [
    initConfigStartRoute,
    {
      path: 'step1',
      name: 'school_manage_init_step1',
      component: () => import('@/views/school-manage-init/Step1.vue'),
      meta: {
        title: '初始化设置',
      },
    },
    {
      path: 'step2',
      name: 'school_manage_init_step2',
      component: () => import('@/views/school-manage-init/Step2.vue'),
      meta: {
        title: '初始化设置',
      },
    },

    {
      path: 'step3',
      name: 'school_manage_init_step3',
      component: () => import('@/views/school-manage-init/Step3.vue'),
      meta: {
        title: '初始化设置',
      },
    },

    {
      path: 'success',
      name: 'school_manage_init_success',
      component: () => import('@/views/school-manage-init/Success.vue'),
      meta: {
        title: '初始化设置',
      },
    },
  ],
}

// 年度老师学校信息设置
export const annuallyInitRoute: RouteConfig = {
  path: '/school-manage-annually-init',
  name: 'school_manage_annually_init',
  component: () => import('@/views/school-manage-init/annually-init/_AnnuallyInitRouter.vue'),
  meta: {
    title: '年度初始化设置',
  },
  children: [
    {
      path: 'start',
      name: 'school_manage_annually_init_start',
      component: () => import('@/views/school-manage-init/annually-init/Start.vue'),
      meta: {
        title: '新学期初始化设置',
      },
    },
    {
      path: 'confirm-school-change',
      name: 'school_manage_annually_init_confirm-school-change',
      component: () => import('@/views/school-manage-init/annually-init/ConfirmSchoolChange.vue'),
      meta: {
        title: '确认执教学校',
      },
    },
    {
      path: 'confirm-clazz-change',
      name: 'school_manage_annually_init_confirm-clazz-change',
      component: () => import('@/views/school-manage-init/annually-init/ConfirmClazzChange.vue'),
      meta: {
        title: '确认执教班级',
      },
    },
    {
      path: 'confirm-school-clazz',
      name: 'school_manage_annually_init_confirm-school-clazz',
      component: () => import('@/views/school-manage-init/annually-init/ConfirmSchoolClazz.vue'),
      meta: {
        title: '新学期班级情况确认',
      },
    },
    {
      path: 'school-basic',
      name: 'school_manage_annually_init_school_basic',
      component: () => import('@/views/school-manage-init/annually-init/SchoolBasic.vue'),
      meta: {
        title: '基础信息',
      },
    },
    {
      path: 'batch-class-amount',
      name: 'school_manage_annually_init_batch_class_amount',
      component: () => import('@/views/school-manage-init/annually-init/BatchClassAmount.vue'),
      meta: {
        title: '批量创建新学年班级数量',
      },
    },
    {
      path: 'finish',
      name: 'school_manage_annually_init_finish',
      component: () => import('@/views/school-manage-init/annually-init/Finish.vue'),
      meta: {
        title: '新学年设置成功',
      },
    },
  ],
}

export default [initConfigRoute, introRoute, prepareMaterialsRoute, initCertificateRoute, annuallyInitRoute]
